export default "__VITE_ASSET__w7GiW5C___"